module.exports = __webpack_public_path__ + "media/images/clothes2-bd1f481214fab7a030faf21ab4480070.png";